import { FormikProvider, useFormik } from 'formik';
import { useState } from 'react';
import { Button } from '../../components/UI';
import { InputCode } from '../../components/form';
import { Trans, useTranslation } from 'react-i18next';
import { useAuth } from '../../context/Auth';
import { useSignInContext } from './SignInContext';
import { Modal } from '../../components/Modal';
import { logger } from '../../helpers/logger';

const SignInConfirmEmailChange = () => {
  const { t } = useTranslation();
  const { verifyEmail, resendVerifyEmail } = useAuth();
  const { state, dispatch } = useSignInContext();

  const [isLoading, setIsLoading] = useState(false);
  const [verifyEmailErr, setVerifyEmailErr] = useState('');
  const [isVerificationEmailResent, setIsVerificationEmailResent] =
    useState(false);

  const { email } = state;

  const formik = useFormik({
    initialValues: {
      code: '',
    },
    onSubmit: (values) => {
      setIsLoading(true);

      verifyEmail(email, values.code)
        .then((res) => {
          dispatch({
            type: 'SET_LOGGED',
            payload: true,
          });
        })
        .catch((err) => {
          logger.log('verifyEmailChange', err);
          setIsLoading(false);
          setVerifyEmailErr(
            t(`confirmEmailChange.form.error.${err.code}`, {
              defaultValue: t('confirmEmailChange.form.error.general'),
            })
          );
        });
    },
    validateOnMount: true,
  });

  const resendEmail = () => {
    resendVerifyEmail(email!).then(() => {
      setIsVerificationEmailResent(true);
      setTimeout(() => {
        setIsVerificationEmailResent(false);
      }, 30000);
    });
  };

  return (
    <Modal
      isOpen={true}
      backdrop={'solid'}
      handleMerlinLogo={true}
      isClosable={false}
      padding={'huge'}
    >
      <div className={'text-center'}>
        <h1 className={'text-black text-xl font-semibold mb-4 dark:text-white'}>
          {t('confirmEmailChange.title')}
        </h1>
        <p className={'text-grey-50 text-sm whitespace-pre-wrap'}>
          <Trans i18nKey="confirmEmailChange.subtitle" email={email}>
            email sent to
            <span className="text-black font-semibold">{{ email }}</span>
            insert code
          </Trans>
        </p>
        <FormikProvider value={formik}>
          <form onSubmit={formik.handleSubmit}>
            <div className="mt-12">
              <InputCode
                name="code"
                id="code"
                numberOfDigits={6}
                formik={formik}
                label={t('confirmEmailChange.form.label.verificationCode')}
                errorMessage={verifyEmailErr}
              />
            </div>
            <div className="mt-10">
              <Button
                type="submit"
                variant="primary"
                buttonClass="w-64"
                loading={isLoading}
              >
                {t('confirmEmailChange.continue')}
              </Button>
            </div>
          </form>
        </FormikProvider>
        <div className="mt-5">
          <span className="text-grey-80 dark:text-grey-30">
            {t(
              !isVerificationEmailResent
                ? 'confirmEmailChange.notReceived'
                : 'confirmEmailChange.resent'
            )}
          </span>
          <button
            className="text-sm text-black font-semibold dark:text-white"
            onClick={() => resendEmail()}
          >
            {!isVerificationEmailResent && t('confirmEmailChange.sendNew')}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default SignInConfirmEmailChange;
